<template>
  <div class="container-fluid">
    <br />
    <div style="text-align: left">
      <el-button @click="useBindAppleDeveloper=true" type="primary">绑定开发者账号</el-button>
      <el-button @click="gotoAppleDeveloperAccount" type="success">个人开发者中心</el-button>
    </div>
    <p></p>
    <el-table :data="bindAppleDeveloperAccounts">
      <el-table-column prop="appleId" label="Apple Id" width="150">
      </el-table-column>
      <!-- <el-table-column
        prop="password"
        label="专用密码"
        width="150"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="teamId"
        label="team id"
        width="150"
      >
      </el-table-column> -->
      <el-table-column prop="certName" label="证书名" width="400">
      </el-table-column>
      <el-table-column prop="useable" label="是否可用" sortable :formatter="useableFormater"></el-table-column>
      <el-table-column prop="useNum" label="使用数量" sortable width="150"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" :formatter="vueFormatDateTime" sortable width="150">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="unBindApp(bindAppleDeveloperAccounts[scope.$index].id,scope.$index)" type="warning">解绑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <br />
    <el-dialog title="绑定开发者账号" :visible.sync="useBindAppleDeveloper" @open="getMyAppleDeveloper"
      @close="getAppBindAppleDeveloper" width="30%">
      <div v-loading="loading">
        <el-select v-model="appleDeveloperId" filterable placeholder="请选择">
          <el-option v-for="appleDeveloperAccount in appleDeveloperAccounts" :key="appleDeveloperAccount.id"
            :label="appleDeveloperAccount.appleId" :value="appleDeveloperAccount.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="bindAppleDeveloperAccount">绑定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  mounted() {
    var shortLink = this.$route.params.app.shortLink;
    this.appId = this.$route.params.app.id;
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/app/info", {
        link: shortLink,
        authToken: this.getToken()
      })
      .then(response => {
        this.respDataHandle(response.body, respData => {
          this.$emit("setApp", respData);
          //   this.search();
        });
      });
    this.getAppBindAppleDeveloper();
  },
  data() {
    return {
      useBindAppleDeveloper: false,
      appleDeveloperAccounts: [],
      bindAppleDeveloperAccounts: [],
      appleDeveloperId: "",
      loading: false,
      appId: 0
    };
  },
  methods: {
    getMyAppleDeveloper: function() {
      this.loading = true;
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/appleDeveloper/account/list", {
          authToken: this.getToken()
        })
        .then(response => {
          this.respDataHandle(response.body, data => {
            this.appleDeveloperAccounts = data;
            this.loading = false;
          });
        });
    },
    getAppBindAppleDeveloper: function() {
      this.$http
        .post(
          this._Global.HTTP_SERVER +
            "/auth/app/bind/apple/developer/account/list",
          { authToken: this.getToken(), appId: this.appId }
        )
        .then(response => {
          this.respDataHandle(response.body, data => {
            console.log("tag", data);
            this.bindAppleDeveloperAccounts = data;
          });
        });
    },
    bindAppleDeveloperAccount: function() {
      var params = {};
      params.appId = this.appId;
      params.appleDeveloperAccountId = this.appleDeveloperId;
      params.authToken = this.getToken();
      this.$http
        .post(
          this._Global.HTTP_SERVER + "/auth/apple/developer/account/bindApp",
          params
        )
        .then(response => {
          this.respDataHandle(response.body, data => {
            if (data) {
              this.$message({
                message: "个人开发者账号绑定成功",
                type: "success"
              });
            }
          });
        });
    },
    useableFormater: function name(row, column, cellValue) {
      return cellValue ? "正常 " : "禁用";
    },
    gotoAppleDeveloperAccount: function() {
      this.$router.push({ name: "AppleDeveloperAccount" });
    },
    unBindApp: function(adaId, index) {
      this.$http
        .post(
          this._Global.HTTP_SERVER + "/auth/apple/developer/account/unBindApp",
          { authToken: this.getToken, appId: this.appId, adaId: adaId }
        )
        .then(response => {
          this.respDataHandle(response.body, data => {
            if (data) {
              window.layer.msg("解绑定成功");
              this.bindAppleDeveloperAccounts.splice(index, 1);
            }
          });
        });
    }
  },
  components: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AppAppleDeveloperAccount.vue